import { RootDispatch } from "../types";
import { SurveyStep } from "./types";

export type Action = { type: "survey/goToSurveyStep"; step: SurveyStep };

export const goToSurveyStep = (step: SurveyStep) => async (dispatch: RootDispatch) => {
  dispatch({
    type: "survey/goToSurveyStep",
    step: step
  });
};
